// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var JsxRuntime = require("react/jsx-runtime");

function Modal(props) {
  if (!props.show) {
    return null;
  }
  var handleClose = props.handleClose;
  var handleCloseClick = function ($$event) {
    $$event.stopPropagation();
    $$event.preventDefault();
    Curry._1(handleClose, undefined);
  };
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("button", {
                            children: "close",
                            type: "button",
                            onClick: handleCloseClick
                          }),
                      className: "survey-preview-modal__toolbar"
                    }),
                JsxRuntime.jsx("section", {
                      children: props.children,
                      className: "survey-preview-modal__content"
                    })
              ],
              className: "survey-preview-modal"
            });
}

var make = Modal;

exports.make = make;
/* react/jsx-runtime Not a pure module */
